var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccountRed = function SvgAccountRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "account-red_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "none",
    stroke: "#e6142d",
    "data-name": "Ellipse 72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1145.05 -137.05)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.6,
    cy: 7.6,
    r: 7.6,
    fill: "#e6142d",
    "data-name": "Ellipse 70",
    transform: "translate(1156.45 141.8)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#account-red_svg__a)",
    "data-name": "Groupe de masques 25",
    transform: "translate(1145.05 137.05)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.889,
    cy: 15.833,
    fill: "#e6142d",
    "data-name": "Ellipse 71",
    rx: 16.889,
    ry: 15.833,
    transform: "translate(2.111 21.111)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#e6142d",
    "data-name": "Ellipse 73"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 18.5
  }))))));
};
export { SvgAccountRed as ReactComponent };
export default "data:image/svg+xml;base64,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";